module.exports = {"admin":"Administrator","readOnly":"Read-Only","accounting":"Accounting"}